module.exports = __webpack_public_path__ + "img/Z81_07.9d4e1c46.jpg";